import React from 'react'
import { Users } from 'lucide-react'
import InvestorCard from './InvestorCard'
import Badge from './ui/Badge'
import { resolveCommitteeMember } from '../config/ondsConfig'
import { actionMeta } from '../utils/tone'

export default function CommitteeGrid({ committee }) {
  if (!committee?.length) return null
  const tally = committee.reduce((acc, o) => {
    const label = actionMeta(o.action).label
    acc[label] = (acc[label] ?? 0) + 1
    return acc
  }, {})

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Users className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
          <h2 className="text-lg font-bold">The Committee</h2>
          <span className="text-sm text-[var(--onds-text-dim)]">{committee.length} legendary operators</span>
        </div>
        <div className="hidden md:flex items-center gap-2">
          {Object.entries(tally).map(([label, count]) => (
            <span key={label} className="onds-chip" style={{ color: 'var(--onds-text-dim)' }}>
              {label}: {count}
            </span>
          ))}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {committee.map((opinion) => (
          <InvestorCard key={opinion.memberId} member={resolveCommitteeMember(opinion)} opinion={opinion} />
        ))}
      </div>
    </div>
  )
}
